import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import ChangePassword from './components/ChangePassword';
import ProtectedRoute from './components/ProtectedRoute';
import RequestManagement from './components/admin/RequestManagement';
import UserManagement from './components/admin/UserManagement';
import UserDetail from './components/admin/UserDetail';
import CategoryManagement from './components/admin/CategoryManagement';
import SkillManagement from './components/profile/SkillManagement';
import ProfileDetail from './components/profile/ProfileDetail';
import AdminUserSkills from './components/admin/AdminUserSkills';
import AccountPage from './components/ledger/AccountPage';
import RegistraScambio from './components/ledger/RegistraScambio';
import UserDirectory from './components/UserDirectory';
import MyExchangeRequests from './components/exchanges/MyExchangeRequests';
import AllExchangeRequests from './components/exchanges/AllExchangeRequests';
import Regolamento from './components/Regolamento';
import Header from './components/common/Header';
import './App.css';

const AUTH_PATHS = ['/login', '/register', '/change-password'];

function AppContent() {
  const location = useLocation();
  const isAuthPage = AUTH_PATHS.includes(location.pathname);

  return (
    <>
      <Header />
      <main
        className={[
          'container-page pb-10',
          isAuthPage ? 'pt-0' : 'pt-14 md:pl-64 md:pt-6',
        ].join(' ')}
      >
        <Routes>
          {/* Rotte pubbliche */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Rotte protette */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <AccountPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/registra-scambio"
            element={
              <ProtectedRoute>
                <RegistraScambio />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfileDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/skills"
            element={
              <ProtectedRoute>
                <SkillManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/utenti"
            element={
              <ProtectedRoute>
                <UserDirectory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/regolamento"
            element={
              <ProtectedRoute>
                <Regolamento />
              </ProtectedRoute>
            }
          />
          <Route
            path="/le-mie-richieste"
            element={
              <ProtectedRoute>
                <MyExchangeRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />

          {/* Rotte di amministrazione */}
          <Route
            path="/admin/requests"
            element={
              <ProtectedRoute allowedRoles={['admin', 'moderator', 'superadmin']}>
                <RequestManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute allowedRoles={['admin', 'moderator', 'superadmin']}>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users/:id"
            element={
              <ProtectedRoute allowedRoles={['admin', 'moderator', 'superadmin']}>
                <UserDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users/:id/skills"
            element={
              <ProtectedRoute allowedRoles={['admin', 'moderator', 'superadmin']}>
                <AdminUserSkills />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/categories"
            element={
              <ProtectedRoute allowedRoles={['admin', 'moderator', 'superadmin']}>
                <CategoryManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/exchange-requests"
            element={
              <ProtectedRoute allowedRoles={['admin', 'moderator', 'superadmin']}>
                <AllExchangeRequests />
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <div className="app-shell">
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
